import MenuLink from '../components/menu-link.vue';
import IconExternal from '../components/icon/external.vue';
export default {
  components: {
    IconExternal,
    MenuLink
  }
};